<template>
  <!-- <table class="table table-hover table-borderless table-striped" cellspacing="0" width="100%">
    <thead>
        <tr>
          <td class="v-align-middle">
            Description
          </td>
          <td class="v-align-middle">
            Quantité
          </td>
          <td class="v-align-middle">
            Prix
          </td>
          <td class="v-align-middle">
              Status du panier
          </td>
          <td class="v-align-middle">
              Email
          </td>
          <td class="v-align-middle">
              Etat (SAP) du panier
          </td> -->

          <!-- <td class="v-align-middle">
              Acompte
          </td>
          <td class="v-align-middle">
              Total (H.T.)
          </td>
          <td class="v-align-middle">
              T.V.A (Taux)
          </td>
          <td class="v-align-middle">
              T.V.A (Montant)
          </td>
          <td class="v-align-middle">
              Total (T.T.C)
          </td> -->
<!--
          <td>
              Opérations
          </td>  -->
    <cart-item v-if="renderComp" :cart="getactivecart" :active="getactivecart" @cleancart="$emit('cleancart', $event)" @deletesuborder="$emit('deletesuborder', $event)">
    </cart-item>
    <!-- </tbody>
  </table> -->
</template>

<script>
import CartItem from './CartItem'

export default {

  props:["active"],
  components:
    {
      CartItem
    },

  computed:{

    getactivecart (){
      if (this.active)
        return this.active
    },

    renderComp () {
      return !_.isEmpty(this.active) && this.active.hasOwnProperty('id')
    }
  }
}

</script>



// WEBPACK FOOTER //
// client/components/Catalog/Carts.vue